import React, { useContext } from 'react'

// Node Modules
import { DomElement } from 'html-react-parser'

// Components
import TabBar from 'components/xis/TabBar'

//styles
import styles from './Placeholders.module.scss'

// Context
import { DocsetContext } from 'context/content-context'

export default ({ attribs }:DomElement, params:any, options:any) => {
  const docset = useContext(DocsetContext)
  const nav = attribs && attribs['file']

  if (!nav || !docset) {
    return <React.Fragment />
  }

  return <div className={styles.tabbar}><TabBar alias={docset.id} cfr={docset.version} nav={nav} /></div>
}